export interface LoginData {
  userName?: string;
  password?: string;
  loginToken?: string;
  accessToken?: string;
  rememberMe?: boolean;
  isZendesk?: boolean;
  returnTo?: string;
  microsoftAccount?: any; 
}

export enum ELoginAuthMethod {
  USERNAME_PASSWORD = 'USERNAME_PASSWORD',
  GOOGLE = 'GOOGLE',
  MICROSOFT = 'MICROSOFT',
  ACCESS_TOKEN= 'ACCESS_TOKEN'
}

export interface LoginNotificationData {
  msg: string;
  type: 'success' | 'error';
}

export type ModalState =
  | 'login'
  | 'resetPassword'
  | 'forgetPassword'
  | 'finishAccount';

export interface LoginPayload {
  userId: string;
  authJwt?: string;
  currentPublisherId?: string;
}
